import axios from "axios";
import {
  getToken,
  updateToken,
  authRequired,
  invalidarSessao,
  getSessionStatus,
  negarAcesso
} from "../shared/keycloak";

function createApi(baseURL) {
  const api = axios.create({ baseURL });

  if (authRequired) {
    api.interceptors.request.use(async (config) => {
      await updateToken(30);
      if (!getToken())
        throw Object.assign(
          new Error("Sessão indisponível. Entre novamente."),
          { status: 401 }
        );
      if (!getSessionStatus().hasAccess)
        throw Object.assign(
          new Error("Você não tem permissão para acessar o eSocial."),
          { status: 403 }
        );
      // eslint-disable-next-line
      config.headers.Authorization = `Bearer ${getToken()}`;
      return config;
    });
  }

  api.interceptors.response.use(
    (response) => response,
    async (error) => {
      const status = error.response?.status || error.status;
      const config = error.config;
      if (
        authRequired &&
        status === 401 &&
        config &&
        !config._sessionRetry &&
        ["get", "head"].includes(config.method)
      ) {
        config._sessionRetry = true;
        await updateToken(-1);
        return api(config);
      }
      if (authRequired && status === 401) invalidarSessao();
      if (status === 403) negarAcesso();
      const data = error.response?.data;
      const message =
        status === 401
          ? authRequired
            ? "Sua sessão expirou. Entre novamente para continuar."
            : "O serviço exige autenticação, mas o login não está configurado nesta aplicação. Contate o suporte."
          : status === 403
          ? "Você não tem permissão para esta operação."
          : typeof data === "object"
          ? data?.message || data?.detail || data?.mensagem
          : undefined;
      throw Object.assign(
        new Error(
          message ||
            error.message ||
            "Não foi possível comunicar com o serviço. Tente novamente."
        ),
        { status, isRequestError: !error.response || status >= 500 }
      );
    }
  );

  return api;
}

export function createQueryFetcher(api) {
  return ({ queryKey }) => {
    const args = Array.isArray(queryKey) ? queryKey : [queryKey];
    return api(...args).then((res) => res.data);
  };
}

export default createApi;
